import { Component, ComponentFactoryResolver, ComponentRef, ElementRef, Input, OnInit, Renderer2, ViewChild } from "@angular/core";
import { HCITransmittalTemplateComponent } from "../templates/hci-transmittal/hci-transmittal-template.component";
import { CommonTransmittalTemplateComponent } from "../templates/template_common/transmittal-template-common.component";
import { TransmittalTemplateComponent } from "../transmittal-template/transmittal-template.component";
import { TransmittalTemplateDirective } from "../transmittal-template/transmittal-template.directive";

const componentMapper:any = {
    common: CommonTransmittalTemplateComponent,
    hci:HCITransmittalTemplateComponent
};

@Component({
    selector: "app-transmittal-view",
    templateUrl: "./transmittal-view.component.html"
})
export class TransmittalViewComponent implements OnInit {
    componentRef!: ComponentRef<any>;
    private _transmittalData!: TransmittalTemplateComponent;
    @Input() set transmittalData(data: TransmittalTemplateComponent) {     
        if (!!data) {
            this._transmittalData = data;
            this.loadComponent();
            this.updateProperties();
        }
    }
    @ViewChild(TransmittalTemplateDirective,{static:true}) transmittalHost!: TransmittalTemplateDirective;

    constructor(private componentFactoryResolver: ComponentFactoryResolver, private elRef: ElementRef) {
    }
    ngOnInit() {
    }

    loadComponent() {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentMapper[this._transmittalData.templateName]);
        const viewContainerRef = this.transmittalHost.viewContainerRef;
        viewContainerRef.clear();
        this.componentRef = viewContainerRef.createComponent(componentFactory);
    }
    public getHtmlContent() {
        return this.elRef.nativeElement.innerHTML;
    }

    public updateProperties() {
        this.componentRef.instance.to = this._transmittalData.to;
        this.componentRef.instance.date = this._transmittalData.date;
        this.componentRef.instance.edrcRef = this._transmittalData.edrcRef;
        this.componentRef.instance.cusRef = this._transmittalData.cusRef;
        this.componentRef.instance.subject = this._transmittalData.subject;
        this.componentRef.instance.projName = this._transmittalData.projName;
        this.componentRef.instance.distributionDetails = this._transmittalData.distributionDetails;
        this.componentRef.instance.docDetails = this._transmittalData.docDetails;
        this.componentRef.instance.attention = this._transmittalData.attention;
        this.componentRef.instance.From = this._transmittalData.From;
        this.componentRef.instance.message_No = this._transmittalData.message_No;
        this.componentRef.instance.message_id = this._transmittalData.message_id;
        this.componentRef.instance.workflowId = this._transmittalData.workflowId;
        this.componentRef.instance.is_Show_Attachment_In_DTN = this._transmittalData.is_Show_Attachment_In_DTN;
        this.componentRef.instance.task_id_list = this._transmittalData.task_id_list;
        this.componentRef.instance.message_Note = this._transmittalData.message_Note;
        this.componentRef.instance.fileDetails = this._transmittalData?.fileDetails;
    }
}